import { WizardStep } from "@/shared/Wizard/models/WizardStep";
import { WizardStepContent } from "@/shared/Wizard/models/WizardStepContent";
import { Component } from "vue";
import { AdvancedAnalysisWizardSharedModel } from "./AdvancedAnaylsisWizardSharedModel";
import { AdvancedAnalysisWizardStepType } from "./AdvancedAnyalsisWizardStepType";



export class AdvancedAnalysisWizardStep extends WizardStep<
    AdvancedAnalysisWizardSharedModel,
    (typeof AdvancedAnalysisWizardStepType)[keyof typeof AdvancedAnalysisWizardStepType]> {

    constructor(public title: string,
        public icon: any,
        public stepContent: WizardStepContent<AdvancedAnalysisWizardSharedModel> | Array<WizardStepContent<AdvancedAnalysisWizardSharedModel>>,
        public type: (typeof AdvancedAnalysisWizardStepType)[keyof typeof AdvancedAnalysisWizardStepType],
        public statusComponent?: Component
    ) {
        super();
    }

}